export const FLAG = "sync_wattics";
export const SYNC_TYPE = "oauth.prod.1_0";
export const EXTENDED = 'yes';
